import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import {
    Modal,
    Button,
    Input,
    Select,
    DatePicker,
    Form,
    message,
    Upload,
} from "antd";

import { PlusOutlined } from '@ant-design/icons';

import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/date-picker/locale/zh_CN';

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 18, offset: 1 }
};

const buttonItemLayout = {
    wrapperCol: { span: 24, offset: 0 }
};

function FormMoudle(props:any,ref:any) {
    const [ isVisible, setIsVisible ] = useState(false);
    const [ isEdit, setIsEdit ] = useState(false);

    const [ id, setId ] = useState(0);

    const [ startTime, setStartTime ] = useState("");
    const [ endTime, setEndTime ] = useState("");

    const [ mainBody, setMainBody ] = useState("");
    const [ fileName, setFileName ] = useState("");

    const [ mainBody2, setMainBody2 ] = useState("");
    const [ fileName2, setFileName2 ] = useState("");

    const [forms] = Form.useForm();

    const { addBidInfo, updateBidInfo, uploadFile } = window.$axios.request;

    useEffect(() => {
        if(!isVisible){
            forms.resetFields();
            setMainBody("");
            setFileName("");
            setMainBody2("");
            setFileName2("");
            setIsEdit(false);
        }
    }, [ isVisible ]);

    //父组件调用子组件的方法 放在useImperativeHandle里面 可以写多个函数
    useImperativeHandle(ref,()=>{
        return {
            _Edit(item:any){
                console.log(item)
                setIsVisible(true);
                setIsEdit(true);
                setId(item.id);
                setFileName(item.mainBody.split("").reverse().join("").split("/")[0].split("").reverse().join(""));
                setMainBody(item.mainBody);
                if(item.attachmentBody != null){
                    setFileName2(item.attachmentBody.split("").reverse().join("").split("/")[0].split("").reverse().join(""));
                    setMainBody2(item.attachmentBody);
                }
                forms.setFieldsValue({ 
                    mainTitle: item.mainTitle, 
                    companyName: item.companyName, 
                    beginDate: moment(item.beginDate), 
                    endDate: moment(item.endDate), 
                    bidStatus: item.bidStatus+"", 
                    bidType: item.bidType+"" 
                });
            },
            _Add(value2:any){
                setIsVisible(true);
            }
        }
    })

    const _getTime = (time:any) => {
        let newTime = new Date(time);
        let month = (newTime.getMonth() + 1)>9?(newTime.getMonth() + 1):"0" + (newTime.getMonth() + 1);
        let day = newTime.getDate()>9?newTime.getDate():"0" + newTime.getDate();
        return newTime.getFullYear() + "-" + month + "-" + day;
    }

    const _addHandleCancel = (value:any) => {
        setIsVisible(value)
    }

    const onFinish = (values:any) => {
        let newValues = {
            ...values,
            beginDate: values.beginDate.format('YYYY-MM-DD'),
            endDate: values.endDate.format('YYYY-MM-DD'),
            mainBody: mainBody,
            attachmentBody: mainBody2
        }
        if (!isEdit) {
            addBidInfo({},{...newValues}).then((res:any)=> {
                if(res.code == 1000){
                    message.success('新增成功!');
                    props.propsFunc();
                    setIsVisible(false);
                    return false;
                }
                message.error(res.msg);
            }).catch((err:object) => {
                message.error("新增失败!");
            })
        }else{
            updateBidInfo({},{...newValues,id:id}).then((res:any)=> {
                if(res.code == 1000){
                    message.success('编辑成功!');
                    props.propsFunc();
                    setIsVisible(false);
                    return false;
                }
                message.error(res.msg);
            }).catch((err:object) => {
                message.error("编辑失败!");
            })
        }
    };

    const renderForm = () => {
        const uploadOptions = {
            accept: ".pdf, .png, .jpg, .jpeg",
            showUploadList: false,
            multiple: false,
            customRequest: (res: any) => {
                if(res.file.size / 1024 / 1024 > 50 ){
                    message.error("文件不能超过50M!");
                    return false
                }
                
                let name = res.file.name;
                var formData = new FormData();
                formData.append("multipartFile", res.file);

                uploadFile(formData)
                .then((res:any) => {
                    if(res.code == 1000){
                        message.success('上传成功!');
                        setFileName(name);
                        setMainBody(res.data.msg);
                        return false;
                    }
                    message.error("上传失败!");
                })
                .catch((err:any) => {
                    message.error("上传失败!");
                })
            }
        };
        const uploadOptions2 = {
            // accept: ".pdf, .png, .jpg, .jpeg",
            showUploadList: false,
            multiple: false,
            customRequest: (res: any) => {
                if(res.file.size / 1024 / 1024 > 1000 ){
                    message.error("文件不能超过1000M!");
                    return false
                }
                
                let name = res.file.name;
                var formData = new FormData();
                formData.append("multipartFile", res.file);

                uploadFile(formData)
                .then((res:any) => {
                    if(res.code == 1000){
                        message.success('上传成功!');
                        setFileName2(name);
                        setMainBody2(res.data.msg);
                        return false;
                    }
                    message.error("上传失败!");
                })
                .catch((err:any) => {
                    message.error("上传失败!");
                })
            }
        };
        const uploadButton = (
            <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
            </div>
        );

        return (
            <Form layout="horizontal" {...formItemLayout}
            form={forms}
            onFinish={onFinish}
            initialValues={{ mainTitle: "", companyName: "", beginDate: "", endDate: "", bidStatus: "", bidType: "" }}
            >
                <Form.Item
                    label="标题"
                    name="mainTitle"
                    rules={[
                        {required:true,message:"请输入标题"},
                    ]}
                >
                    <Input
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请输入标题"
                        maxLength={200}
                    />
                </Form.Item>
                <Form.Item
                    label="公司名称"
                    name="companyName"
                    rules={[
                        {required:true,message:"请输入公司名称"},
                    ]}
                >
                    <Input
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请输入公司名称"
                        maxLength={200}
                    />
                </Form.Item>

                <Form.Item
                    label="开始时间"
                    name="beginDate"
                    rules={[
                        {required:true,message:"请选择开始时间"},
                    ]}
                >
                    <DatePicker
                        locale={locale}
                        value={moment(startTime)}
                        disabledDate={(current:any) => {
                            return current < moment().subtract(1, 'days');  
                        }}
                        onChange={(date,dateString) => {
                            setStartTime(dateString);
                            if(moment(dateString).valueOf() >= moment(endTime).valueOf()){
                                forms.setFieldsValue({ 
                                    endDate: moment(_getTime(moment(dateString).valueOf() + 24*60*60*1000))
                                });
                                setEndTime(_getTime(moment(dateString).valueOf() + 24*60*60*1000));
                            }
                        }}
                        format="YYYY-MM-DD"
                        style={{ width: 300, marginLeft: 0 }}
                    />
                </Form.Item>

                <Form.Item
                    label="结束时间"
                    name="endDate"
                    rules={[
                        {required:true,message:"请选择结束时间"},
                    ]}
                >
                    <DatePicker
                        locale={locale}
                        value={moment(endTime)}
                        disabledDate={(current:any) => {
                            return current.valueOf() <= moment(startTime).valueOf(); 
                        }}
                        onChange={(date,dateString) => {
                            setEndTime(dateString);
                        }}
                        format="YYYY-MM-DD"
                        style={{ width: 300, marginLeft: 0 }}
                    />
                </Form.Item>



                <Form.Item
                    label="状态"
                    name="bidStatus"
                    rules={[
                        {required:true,message:"请选择状态"},
                    ]}
                >
                    <Select
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请选择状态"
                        maxLength={200}
                    >
                        <Select.Option value="-1">已废除</Select.Option>
                        <Select.Option value="0">未开始</Select.Option>
                        <Select.Option value="1">进行中</Select.Option>
                        <Select.Option value="2">已结束</Select.Option>
                        <Select.Option value="3">已失效</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label="招标部门"
                    name="bidType"
                    rules={[
                        {required:true,message:"请选择招标部门"},
                    ]}
                >
                    <Select
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请选择招标部门"
                        maxLength={200}
                    >
                        <Select.Option value="1">采购招标</Select.Option>
                        <Select.Option value="2">设计招标</Select.Option>
                        <Select.Option value="3">工程招标</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item label="正文" 
                    name="mainBody" 
                    rules={[
                        {
                            validator(rule, value) {
                                if (!mainBody) {
                                    return Promise.reject("请上传文件");//新的form的验证回调方式
                                }
                                return Promise.resolve();
                            },
                        }
                    ]}
                >
                    <div className="uploadFilesWrap">
                        <div className="fileWrap">
                            <a href={mainBody} target="_blank">{fileName}</a>
                        </div>
                        <div className="upload">
                            <Upload {...uploadOptions} listType="picture-card">
                                {uploadButton}
                            </Upload>
                        </div>
                    </div>
                    <div style={{color:"#666666"}}>仅限pdf,png,jpg格式 50M以内</div>
                </Form.Item>

                <Form.Item label="附件" 
                    name="mainBody2"
                >
                    <div className="uploadFilesWrap">
                        <div className="fileWrap">
                            <a href={mainBody2} target="_blank">{fileName2}</a>
                        </div>
                        <div className="upload">
                            <Upload {...uploadOptions2} listType="picture-card">
                                {uploadButton}
                            </Upload>
                        </div>
                    </div>
                    <div style={{color:"#666666"}}>1000M以内</div>
                </Form.Item>

                <Form.Item
                    className="formItem"
                    {...buttonItemLayout}
                    style={{ textAlign: "right" }}
                >   
                    <Button
                        type="default"
                        onClick={() => {
                            _addHandleCancel(false);
                        }}
                    >
                        取消
                    </Button>
                    <Button style={{ marginLeft: 10 }} type="primary" htmlType="submit">保存</Button>
                </Form.Item>
            </Form>
        )
    }

    return (
        <React.Fragment>
            <Modal
                 title={isEdit?"编辑招标":"新建招标"}
                 visible={isVisible}
                 getContainer={false}
                 forceRender
                 footer={null}
                 onCancel={() => {_addHandleCancel(false)}}
                 maskClosable={false}
                 destroyOnClose
            >
                {renderForm()}
            </Modal>
        </React.Fragment>
    )
}

export default (forwardRef(FormMoudle));
